import { v4 as uuidv4 } from 'uuid';
import { TRAVELER_V1_CLIENT_ID_ONLINE } from '../constants/travelerDataConstants';

export const makeFetch = async ({
  url,
  body,
  method,
}) => {
  const correlationId = uuidv4();
  const response = await fetch(url, {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      clientId: TRAVELER_V1_CLIENT_ID_ONLINE,
      correlation_id: correlationId,
    },
    body: JSON.stringify(body),
  });

  return {
    response,
    correlationId,
  };
};

export const makePost = async ({
  url,
  body,
}) => makeFetch({
  url,
  body,
  method: 'POST',
});

export const makePut = async ({
  url,
  body,
}) => makeFetch({
  url,
  body,
  method: 'PUT',
});
